if (!customElements.get("show-more-button")) {
	customElements.define(
		"show-more-button",
		class ShowMoreButton extends HTMLElement {
			constructor() {
				super();
				const button = this.querySelector("button");
				button.addEventListener("click", (event) => {
					this.expandShowMore(event);
					const nextElementToFocus = event.target.closest(".parent-display").querySelector(".show-more-item");
					if (nextElementToFocus && !nextElementToFocus.classList.contains("hidden") && nextElementToFocus.querySelector("input")) {
						nextElementToFocus.querySelector("input").focus();
					}
				});
			}
			expandShowMore(event) {
				const parentDisplay = event.target.closest('[id^="Show-More-"]').closest(".parent-display");
				this.querySelectorAll(".label-text").forEach((element) => element.classList.toggle("hidden"));
				parentDisplay.querySelectorAll(".show-more-item").forEach((item) => item.classList.toggle("hidden"));
				if (!this.querySelector(".label-show-less")) {
					this.classList.add("hidden");
				}
			}
		}
	);
}
document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll(".button-show-more").forEach(function (btn) {
		btn.addEventListener("click", function () {
			var container = btn.closest(".accordion-details__content");
			if (!container) return;
			var items = container.querySelectorAll(".show-more-item");
			items.forEach(function (el) {
				el.classList.toggle("hidden");
			});
			var showMore = btn.querySelector(".label-show-more");
			var showLess = btn.querySelector(".label-show-less");
			if (showMore && showLess) {
				showMore.classList.toggle("hidden");
				showLess.classList.toggle("hidden");
			}
		});
	});
});
